import React, { useContext, useEffect, useState } from 'react';
import { UserProfileContext } from '../../../context/userProfileContext';
import TimeLine from '../timeLine/TimeLine';
import MainData from './MainData';
import { createBankFees } from '../../../utils/api/bankFees';

const BankFees = () => {
    const { profileContextData } = useContext(UserProfileContext);
    const { client } = profileContextData;

    const handleCreateRound = async (reason: string) => {
        await createBankFees(client._id, reason);
    };

    return (
        <div className={`regular-modules ${profileContextData.expandClientData ? 'data-expanded' : ''}`}>
            <div className={'timeline-row-wrapper not-active-module'}>
                <TimeLine onCreateRound={handleCreateRound} />
            </div>
            {profileContextData.currentRound ? <MainData /> : null}
        </div>
    );
};

export default BankFees;
